import { Controller } from "@hotwired/stimulus"

// Drives the conference course cart: add/remove courses against the session-backed
// cart and swap in the server-rendered drawer. Turbo is disabled on the pages
// layout, so we drive everything with fetch + innerHTML swaps instead of streams.
export default class extends Controller {
  static targets = ["drawer", "overlay", "badge"]
  static values = { url: String }

  // A trigger may carry data-quantity (the offering page's licences, TMS-1611);
  // without one the server adds a single licence.
  add(event) {
    const { slug, quantity } = event.currentTarget.dataset
    if (!slug) return

    const query = quantity ? `?quantity=${encodeURIComponent(quantity)}` : ""
    this.request(`${this.urlValue}/${slug}${query}`, "POST").then(() => this.open())
  }

  remove(event) {
    const slug = event.currentTarget.dataset.slug
    if (!slug) return

    this.request(`${this.urlValue}/${slug}`, "DELETE")
  }

  toggle() {
    this.drawerTarget.hasAttribute("hidden") ? this.open() : this.close()
  }

  open() {
    this.drawerTarget.removeAttribute("hidden")
    this.overlayTarget.removeAttribute("hidden")
    this.drawerTarget.classList.add("cf-cart-drawer--open")
  }

  close() {
    this.drawerTarget.setAttribute("hidden", "")
    this.overlayTarget.setAttribute("hidden", "")
    this.drawerTarget.classList.remove("cf-cart-drawer--open")
  }

  async request(url, method) {
    const response = await fetch(url, {
      method,
      headers: {
        "X-CSRF-Token": this.csrfToken,
        Accept: "text/html"
      },
      credentials: "same-origin"
    })

    if (!response.ok) return

    const html = await response.text()
    this.drawerTarget.innerHTML = html
    this.syncBadge()
  }

  syncBadge() {
    const counter = this.drawerTarget.querySelector("[data-cart-count]")
    const count = counter ? parseInt(counter.dataset.cartCount, 10) : 0

    this.badgeTarget.textContent = count
    if (count > 0) {
      this.badgeTarget.removeAttribute("hidden")
    } else {
      this.badgeTarget.setAttribute("hidden", "")
    }
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}
